import { useTheme } from "@emotion/react";
import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import { ResourceAbouts, ServiceAbouts } from "../../common/const";
import CommonCard from "../../common/components/CommonCard";

const AboutUs = ({
  isServices
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        py: 8
      }}
    >
      {isServices ? (
        <Container maxWidth="xl">
          <Typography align="center">What are My DCP Services?</Typography>
          <Typography fontSize={45} align="center" color={theme.palette.secondary.main} fontWeight="600">
            A Smarter Way to Plan Your College
          </Typography>
          <Typography fontSize={45} align="center" color={theme.palette.secondary.main} fontWeight="600" sx={{ mt: -1 }}>
            Future
          </Typography>
          <Grid container spacing={2}>
            {ServiceAbouts.map((a, index) => (
              <Grid item md={4} key={index}>
                <CommonCard
                  paddingBottom="0px"
                  borderRadius={1}
                  border={`1px solid #EFEFEF`}
                  background={theme.palette.background.main}
                  content={
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      mt={2}
                      height="30vh"
                    >
                      <img src={a.image} alt='about' height="70px" />
                      <Typography fontWeight={600} fontSize={24} mt={2} mb={1.5} color={theme.palette.secondary.main} textAlign="center">{a.title}</Typography>
                      <Typography fontWeight={600} fontSize={12} mb={3} textAlign="center" color={theme.palette.background.dark}>{a.subtitle}</Typography>
                    </Box>
                  }
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      ) : (
        <Container maxWidth="xl">
          <Typography align="center">What are My DCP Resources?</Typography>
          <Typography fontSize={45} align="center" color={theme.palette.secondary.main} fontWeight="600">
            Connect with DCP Experts Who Guide Your
          </Typography>
          <Typography fontSize={45} align="center" color={theme.palette.secondary.main} fontWeight="600" sx={{ mt: -1 }}>
            Success
          </Typography>
          <Grid container spacing={2}>
            {ResourceAbouts.map((a, index) => (
              <Grid item md={4} key={index}>
                <CommonCard
                  paddingBottom="0px"
                  borderRadius={1}
                  border={`1px solid #EFEFEF`}
                  background={theme.palette.background.main}
                  content={
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      mt={2}
                      height="30vh"
                    >
                      <img src={a.image} alt='about' height="70px" />
                      <Typography fontWeight={600} fontSize={24} mt={2} mb={1.5} color={theme.palette.secondary.main} textAlign="center">{a.title}</Typography>
                      <Typography fontWeight={600} fontSize={12} mb={3} textAlign="center" color={theme.palette.background.dark}>{a.subtitle}</Typography>
                    </Box>
                  }
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      )}
    </Box>
  )
}

export default AboutUs;